import * as React from 'react';
import { EUnavailableReason } from '../../../../../../redux/reducers';
import { DeniedBySanctions } from '../DeniedBySanctions';
import { NoPhotos } from '../NoPhotos';
import { OnlyAfterPremiumExpiration } from '../OnlyAfterPremiumExpiration';
import { OnlyForFairPlayersContainer } from '../OnlyForFairPlayers';
import { TopUnavailable } from '../TopUnavailable';
import { IUnavailableReasonProps } from './types';

export const UnavailableReason = (props: IUnavailableReasonProps) => {
  const { reasonType } = props;

  switch (reasonType) {
    case EUnavailableReason.noPhotos:
      return <NoPhotos />;

    case EUnavailableReason.onlyInAction:
      return <OnlyForFairPlayersContainer />;

    case EUnavailableReason.deniedBySanctions:
      return <DeniedBySanctions />;

    case EUnavailableReason.top3ServiceDenied:
      return <TopUnavailable />;

    case EUnavailableReason.onlyAfterPremiumServiceExpiration:
      return <OnlyAfterPremiumExpiration />;

    default:
      return null;
  }
};
